let EBOOK_API_URL = ``;
let EBOOK_AMAZON_CLOUD_URL = ``;
let ebook_player = ``;
let firebaseConfig;

// 判斷環境配置
if (window.location.hostname === "a-dev.tbbt.com.tw" || window.location.hostname === "localhost"){
  EBOOK_AMAZON_CLOUD_URL = "https://api-edisc3.hle.com.tw/edisc-token-interact";
  EBOOK_API_URL = "https://qa-edisc3.hle.com.tw/webapi";
  ebook_player = "https://h5.hle.com.tw/toolbar/develop/index.html"

} else if (window.location.hostname === "qa-textbook.hle.com.tw" || window.location.hostname === "qa-reference.hle.com.tw"){
  EBOOK_AMAZON_CLOUD_URL = "https://api-edisc3.hle.com.tw/edisc-token-interact";
  EBOOK_API_URL = "https://qa-edisc3.hle.com.tw/webapi";
  firebaseConfig = {
    apiKey: "AIzaSyAL21pfF-Uspmx_gFugCttrQFp7xOGkfjs",
    authDomain: "h5books-qaedisc3.firebaseapp.com",
    databaseURL: "https://h5books-qaedisc3-default-rtdb.firebaseio.com",
    projectId: "h5books-qaedisc3",
    storageBucket: "h5books-qaedisc3.appspot.com",
    messagingSenderId: "919778938222",
    appId: "1:919778938222:web:5359c613f0bc60bdcbc57f",
    measurementId: "G-57L3M5Z8R1"
  };
  ebook_player = "https://h5.hle.com.tw/toolbar/develop/index.html"

} else if (window.location.hostname === "textbook.hle.com.tw" || window.location.hostname === "reference.hle.com.tw"){
  EBOOK_AMAZON_CLOUD_URL = "https://api-edisc3.hle.com.tw/edisc-token-interact";
  EBOOK_API_URL = "https://edisc3.hle.com.tw/webapi";
  firebaseConfig =  {
    apiKey: "AIzaSyDqWzzLKGdz_qCKgf7YA2_Nfv_HcRZ96G8",
    authDomain: "h5books-edisc3.firebaseapp.com",
    databaseURL: "https://h5books-edisc3-default-rtdb.firebaseio.com",
    projectId: "h5books-edisc3",
    storageBucket: "h5books-edisc3.appspot.com",
    messagingSenderId: "297648181536",
    appId: "1:297648181536:web:a332d50f9561eaeb574745",
    measurementId: "G-EDCT3G2XG7"
  };
  ebook_player = "https://h5.hle.com.tw/toolbar/release/index.html"
}

class EBookService {
  // 取得班級紀錄
  getClassRecord(account, book_code) {
    const data = JSON.stringify({
      "account": account,
      "book_code": book_code
    });

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", `${EBOOK_API_URL}/getLatestRecord`);
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.onreadystatechange = function() {
        if (this.readyState === 4) {
          if (this.status === 200) {
            resolve(this.responseText);
          } else {
            reject(new Error('Failed to get class record'));
          }
        }
      };

      xhr.send(data);
    });
  }

  // 刪除班級紀錄
  deleteClassRecords(account, book_code, subject){
    let data = JSON.stringify({
      "account": account,
      "book_code": book_code,
      "subject": subject
    });
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", `${EBOOK_API_URL}/deleteBookRecord`);
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.onreadystatechange = function() {
        if (this.readyState === 4) {
          if (this.status === 200) {
            resolve(this.responseText);
          } else {
            reject(new Error('Failed to delete clas record'));
          }
        }
      };

      xhr.send(data);
    });
  }

  // 透過 firebase 紀錄 並取得書本
  getRecordEBook(book_code, book_file, subject, email, token){
    let bookCode = book_code;
    let ebook = book_file;
    let ebookPath = ebook.substring(0, ebook.lastIndexOf('/')) + '/ebook';

    let record_subject = subject;
    let oidcEmail = email;
    let oidcToken = token;
    let recordsite_webapi = `${EBOOK_API_URL}/`;
    let website = window.location.origin;

    let encode = "";
    let link = "";

    if (record_subject == null) {
      encode += this.b64EncodeUnicode(
        'email=' + oidcEmail +
        '&api=' + recordsite_webapi +
        '&ebook=' + ebookPath
      );
    } else {
      encode += this.b64EncodeUnicode(
        'email=' + oidcEmail +
        '&api=' + recordsite_webapi +
        '&ebook=' + ebookPath +
        '&record=' + record_subject
      );
    }

    let fbse_date = new Date();
    let fbse = this.formatDate(fbse_date) + "_edsic3web";
    let dt = new Date();

    let key = "edisc3/temp/" + dt.getFullYear() + "/" 
            + this.padLeft((dt.getMonth() + 1) + "", 2) + "/" 
            + this.padLeft(dt.getDate() + "", 2) + "/" + fbse;

    let origin = website;
    link = ebook_player + "?id=" + this.b64EncodeUnicode(bookCode + "," + fbse + "," + origin);

    if (firebase.apps.length === 0){
      firebase.initializeApp(firebaseConfig);
    }

    let value = {
      encode: encode,
      fbse: fbse,
      token: oidcToken
    };

    this.addKeyAndRemoveAfter20Seconds(key, value);
    return link;
  }

  // 透過 amazon 紀錄 並取得書本
  async getRecordEBookAmazon(book_file, subject, email, token){
    const key = await this.getEbookKeyFromAmazonCloud(book_file, subject, email, token);
    let link = ebook_player + "?key=" + key;
    return link;
  }

  getEbookKeyFromAmazonCloud(book_file, subject, email, token){
    let ebook = book_file;
    let ebookPath = ebook.substring(0, ebook.lastIndexOf('/')) + '/ebook';

    let record_subject = subject;
    let oidcEmail = email;
    let oidcToken = token;
    let recordsite_webapi = `${EBOOK_API_URL}/`;

    let encode = "";

    if (record_subject == null) {
      encode += this.b64EncodeUnicode(
        'email=' + oidcEmail +
        '&api=' + recordsite_webapi +
        '&ebook=' + ebookPath
      );
    } else {
      encode += this.b64EncodeUnicode(
        'email=' + oidcEmail +
        '&api=' + recordsite_webapi +
        '&ebook=' + ebookPath +
        '&record=' + record_subject
      );
    }

    let fbse_date = new Date();
    let fbse = this.formatDate(fbse_date) + "_edsic3web";
    console.log("fbse 的內容：", fbse);


    let data = JSON.stringify({
      origin: window.location.origin,
      encode: encode,
      fbse: fbse,
      token: oidcToken
    });

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", EBOOK_AMAZON_CLOUD_URL);
      xhr.setRequestHeader("Content-Type", "text/plain");
      xhr.onreadystatechange = function() {
        if (this.readyState === 4) {
          if (this.status === 200) {
            resolve(this.responseText);
          } else {
            reject(new Error('Failed to write data'));
          }
        }
      };
      xhr.send(data);
    });
  }

  addKeyAndRemoveAfter20Seconds(key, value) {
    const ref = firebase.database().ref(key);
    ref.set(value)
      .then(() => {
        setTimeout(() => {
          firebase.database().ref(key).remove();
          console.log("刪除 key");
        }, 5 * 1000);
      });
  }

  formatDate(date) {
    const year = date.getFullYear();
    const month = this.padLeft(date.getMonth() + 1, 2);
    const day = this.padLeft(date.getDate(), 2);
    const hours = this.padLeft(date.getHours(), 2);
    const minutes = this.padLeft(date.getMinutes(), 2);
    const seconds = this.padLeft(date.getSeconds(), 2);
    const milliseconds = this.padLeft(date.getMilliseconds(), 3);
    return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
  }

  padLeft(num, len) {
    return num.toString().padStart(len, '0');
  }

  b64EncodeUnicode(str) {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
      })
    );
  }
}
